'use client'

// src/core/context/root/context.tsx
import { createContext } from "react";
var context_default = createContext(null);

export {
  context_default
};
//# sourceMappingURL=chunk-4VWYIUCY.mjs.map